import tuner from '../tuner';
import baseState from './baseState';

const state = {
  name: 'stopped',
  enter: function () {
    tuner.boostState.introCount = 0;
    tuner.boostState.outroCount = 0;
    tuner.trigger(tuner.events.stopped);
  },
  play: function () {
    tuner.changeState(tuner.states.connecting, { shouldLogStatus: true });
  },
  playBoostExperience: function () {
    tuner.changeState(tuner.states.connecting, {
      shouldLogStatus: true,
      playBoostExperience: true,
    });
  },
};

export default {
  ...baseState,
  ...state,
};
